import { NgModule } from '@angular/core';
import { AppTextPipe } from './app-text.pipe';
import { AppTextService } from './app-text.service';

@NgModule({
    declarations: [AppTextPipe],
    exports: [AppTextPipe],
    providers: [AppTextService],
})
export class FiAppTextSharedModule {}
